import store from '@store';
import {INDRIVE_ID_PARENT_ORIGIN} from '@core/helpers/constants';

export {INDRIVE_ID_PARENT_ORIGIN};

export const isIndriveIndonesia = () => {
  const {login, dashboard} = store.getState();
  return (
    login.countryCode === 'ID' &&
    (login.theme === 'indrive' || dashboard.isIndrive)
  );
};

export const postIndriveMessage = (
  message: {type: string; payload: Record<string, unknown>},
  legacyTargetOrigin: string
) => {
  if (!isIndriveIndonesia()) {
    window.parent.postMessage(message, legacyTargetOrigin);
    return;
  }
  if (!['SUBMITTED', 'EXIT_APPLICATION', 'TIMEOUT'].includes(message.type))
    return;
  const {loanApplicationStates, dashboard} = store.getState();
  const tile = dashboard.data[0];
  const payload: Record<string, unknown> = {
    loanApplicationId:
      message.payload.loanApplicationId ??
      (loanApplicationStates.loanApplicationId ||
        tile?.ongoingLoanApplicationId ||
        tile?.submittedLoanApplicationId ||
        null),
    status:
      message.payload.status ||
      message.payload.applicationStatus ||
      message.type,
    timestamp: new Date().toISOString(),
  };
  if (
    message.type === 'EXIT_APPLICATION' &&
    'availableLimit' in message.payload
  ) {
    Object.assign(payload, {
      availableLimit: message.payload.availableLimit,
      toHideLimit: message.payload.toHideLimit,
      limitBlocked: message.payload.limitBlocked,
    });
  }
  window.parent.postMessage(
    {type: message.type, payload},
    INDRIVE_ID_PARENT_ORIGIN
  );
};
